window.addEventListener('DOMContentLoaded', () => {
	const promptButtonElements = document.getElementsByClassName('prompt-button');

	const onClickAbort = () => {
		const promptModals = document.getElementsByClassName('prompt-modal-overlay');
		[...promptModals].forEach((el) => el.remove());
	}

	const onClickAccept = (url) => {
		const { origin } = window.location;
		window.location.replace(`${origin}${url}`)
	}

	const onClickPromptButton = (event) => {
		const dataset = event.target.dataset;

		const wrapperEl = document.createElement('div');
		wrapperEl.className = 'prompt-modal modal-content modal-body';
		const paragraphEl = document.createElement('p');
		paragraphEl.innerHTML = dataset.text;
		wrapperEl.appendChild(paragraphEl)
		const buttonWrapperEl = document.createElement('div');
		buttonWrapperEl.className = 'modal-footer';
		const declineButtonEl = document.createElement('button');
		declineButtonEl.innerHTML = dataset?.closeButtonText ? dataset.closeButtonText : 'Cancel';
		declineButtonEl.className = dataset?.closeButtonClassname ? `btn ${dataset.closeButtonClassname}` :'btn btn-light';
		declineButtonEl.onclick = onClickAbort;
		buttonWrapperEl.appendChild(declineButtonEl);
		const acceptButtonEl = document.createElement('button');
		acceptButtonEl.innerHTML = dataset?.approveButtonText ? dataset.approveButtonText : 'Ok';
		acceptButtonEl.className = dataset?.approveButtonClassname ? `btn ${dataset.approveButtonClassname}` : 'btn btn-primary';
		acceptButtonEl.onclick = () => {
			onClickAccept(dataset.url);
		}
		buttonWrapperEl.appendChild(acceptButtonEl);
		wrapperEl.appendChild(buttonWrapperEl);
		const overlayEl = document.createElement('div');
		overlayEl.className = 'prompt-modal-overlay modal fade show'
		const overlayInnerEl = document.createElement('div');
		overlayInnerEl.className = 'modal-dialog modal-dialog-centered'
		overlayInnerEl.appendChild(wrapperEl);
		overlayEl.appendChild(overlayInnerEl);
		document.body.appendChild(overlayEl);
	}

	if (promptButtonElements.length > 0) {
		[...promptButtonElements].forEach((button) => {
			button.addEventListener('click', onClickPromptButton);
		})
	}
})
